import React, {useEffect} from 'react'
import Button from "../atoms/button/button";
import {history} from "../../configureHistory";
import {useStore} from "react-redux";
import {t} from "../../i18n";
import {orderStatuses} from "../constants/orderStatuses";
export default ()=>{
    const passedData: any = useStore().getState().globalReducer.order;
    //window.history.replaceState(null, '', `/${passedData.LinkCode}`);
    let styles: any = useStore().getState().globalReducer.styles;
    const state: any = history.location.state;
    const preview: any = state && state.preview;
    //Redirect to main page if store is empty
    const reqID = sessionStorage && sessionStorage.getItem('reqID');
    const missingState = !state;
    let redirectTo = '';
    if(!passedData.OrderNumber){
        redirectTo = "/";
    } else if(missingState && reqID && reqID !== 'recheck') {
        redirectTo = `/${reqID}`;
    }

    //Navigate after the render is committed. Pushing while rendering re-enters the
    //router listener on the same call stack and overflows it.
    useEffect(()=>{
        if(redirectTo)
            history.push({pathname: redirectTo});
    },[redirectTo]);

    if(redirectTo || missingState) {
        return(<div></div>);
    }

    const onClick = () => {
        const status = +passedData.OrderStatus;
        if (status > 200 && status <= 300) {
            history.push({
                pathname:"/waiting",
                state:{order:passedData}
            });
        } else if (status === 301 || status === 302 || status === 303 || preview) {
            history.push({
                pathname:"/accepted",
                state:{data:passedData, alreadyOpened:true}
            });
        }
        else if (status === 600 || status === 500) {
            history.push({
                pathname:"/summary",
                state: { data: passedData, OrderStatus:orderStatuses.Canceled}
            });
        }
        else if (status === orderStatuses.Removed) {
            history.push({
                pathname:"/summary",
                state: { data: passedData, OrderStatus:orderStatuses.Removed}
            });
        }
        else if (status === 200) {
            history.push({
                pathname:"/register",
                state:{code: passedData.LinkCode}
            });
        }
    };
    const style = {
        background: styles.ManualUpdate.ButtonBackGroundColor,
        borderColor: styles.ManualUpdate.ButtonBackGroundColor,
        minWidth: 250,
        fontSize: 20,
        fontFamily: styles.CommonSettings.FontFamily,
        color: styles.ManualUpdate.ButtonFontColor
    } as React.CSSProperties;


    let styleCommon = {
        overflowWrap:"anywhere",
        fontFamily: styles.CommonSettings.FontFamily,
        color: styles.CommonSettings.FontColor
    } as React.CSSProperties;

    return(
        <div className="container text-center">
            <div className="row">
                <div className="col-12" style={styleCommon}>
                    <h1>{t("ManualUpdate_TextInTheTopOfCommonText")}</h1>
                    <p>{t("CommonText_FirstLine")}</p>
                    <h3>{t("CommonText_SecondLine")}</h3>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <Button disabled={preview} value={t("ManualUpdate_ButtonText")} style={style} classList="btn-warning btn-lg"
                            onButtonClick={() => onClick()}/>
                </div>
            </div>
            <div className="row justify-content-md-center">
                <div className="col-md-auto">
                    <p style={styleCommon}>{t("ManualUpdate_TextAtTheBottom")}</p>
                </div>
            </div>
        </div>
    )
}
